import styled from "styled-components";
import {device} from "../../themes/Breakpoints";


export const HeaderWrap = styled.header`
  background: #022142;
  padding: 0;

  .nav-item {
    position: relative;
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    background-color: white;
    border: 1px solid #ddd;
    display: block;
    list-style: none;
    padding: 0;
    margin: 0;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .dropdown-menu li a {
    text-decoration: none;
    padding: 7px;
    color: black;
    display: block;
  }

  @media screen and (max-width: 1023px) {
    nav ul {
      display: flex;
      flex-direction: column;
    }

    .active ul {
      display: block;
    }

    .main-container {
      display: flex;
      justify-content: space-between;
    }

    .dropdown-menu {
      background: linear-gradient(90deg, #08C73E 0%, #376AA1 100%);
      z-index: 1000;
      left: -15px;
    }

    .dropdown-menu li a {
      white-space: nowrap;
    }
  }
`;
export const HeaderInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  > div {
    flex: 1 1 auto;
  }

  & img {
    display: block;
    object-fit: cover;
    width: 52px;
  }

  & img.main-logo {
    width: auto;
    height: 64px;
    object-fit: contain;
  }

  .burger {
    width: 24px;
    height: 24px;
  }

  .burger-menu {
    display: none;
    cursor: pointer;
  }

  .burger-opened-menu {
    display: none;
  }

  @media screen and (max-width: 1023px) {
    width: 100%;

    & img.main-logo {
      height: 48px;
    }

    .burger-menu {
      display: flex;
      justify-content: flex-end;
    }

    .burger-opened-menu {
      position: absolute;
      top: 100%;
      right: 0;
      border: 1px solid #ddd;
      display: block;
      list-style: none;
      margin: 0;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      width: fit-content;
      min-width: 300px;
      background: rgb(2, 33, 66);
      z-index: 1000;
      flex-direction: column;
      padding-top: 20px;
      padding-bottom: 20px;
    }

    .burger-opened-menu li a {
      text-decoration: none;
      padding: 7px;
      color: white;
      display: block;
    }
  }
`;
export const Nav = styled.nav`
  ul {
    list-style-type: none;
    display: flex;
    align-items: center;

    li a {
      padding: 24px;
      color: #ffffff;
      text-decoration: none;
      font-family: "Saira Semi Condensed", sans-serif;
      font-weight: 500;

      &.active {
        background: #F15A24;
      }
    }

    .active-link {
      background: #F15A24;
    }
  }

  @media ${device.laptop} {
    li a {
      padding: 24px 12px;
      white-space: nowrap;
    }

    .active-link {
      padding: 24px 12px;
    }
  }
`;
export const BtnWrap = styled.div`
  button {
    font-size: 16px;
    font-family: "Saira Semi Condensed", sans-serif;
    font-weight: 600;
    padding: 4px 24px;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 24px;
    opacity: 0.9;
    transition: all 0.3s ease;
    background-color: #fff;
    color: #000000;

    :hover {
      opacity: 1;
    }
  }

  button.sign-in {
    background-color: transparent;
    border: 1px solid #fff;
    color: #fff;
    margin-left: 0;
  }

  @media screen and (max-width: 1023px) {
    display: flex;
    justify-content: center;
  }

  button.sign-up {
    margin-left: 0;
  }
`;
export const HeaderBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: 1023px) {
    display: none;
  }
`;
export const ProfileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  color: #fff;

  a {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #fff;
  }

  img {
    width: 22px;
    height: auto;
  }

  @media screen and (max-width: 1023px) {
    display: none;
  }
`;
export const ProfileInfoMobile = styled.div`
  display: none;
  @media screen and (max-width: 1023px) {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 15px;
    color: #fff;
    margin-top: 8px;
    a {
      display: flex;
      align-items: center;
      gap: 6px;
      color: #fff;
    }

    img {
      width: 22px;
      height: auto;
    }
  }
`;